import React, { useEffect } from 'react';
import { useIntl } from '@leagueplatform/locales';
import { PDPPremiumPaymentMasonrySection } from 'components/premium-payment/pdp-premium-payment-masonry-section.component';
import { PremiumPaymentLayout } from 'components/premium-payment/premium-payment-layout.component';
import { sendPDPPremiumPaymentScreenLoadedEvent } from 'utils/analytics-events';
import { useGoBack } from 'hooks/use-go-back.hook';

const PDPPremiumPaymentPage = () => {
  const { formatMessage } = useIntl();
  const { handleGoBack } = useGoBack();
  const title = formatMessage({ id: 'STR_PREMIUM_OPTIONS' });

  useEffect(() => {
    sendPDPPremiumPaymentScreenLoadedEvent();
  }, []);

  return (
    <PremiumPaymentLayout title={title} goBack={handleGoBack}>
      <PDPPremiumPaymentMasonrySection />
    </PremiumPaymentLayout>
  );
};

export default PDPPremiumPaymentPage;
